class TabsElement extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-tab-content]');
    this.buttons = this.querySelectorAll('[data-tab-controller]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.controller.bind(this, button));
    });

    // State for active button and tab by id
    this.active = this.findId(this.querySelector('[data-tab-controller][aria-expanded="true"]'));
  }

  /**
   * Find the id of the button or tab
   * @param {HTMLElement} element - The button or tab
   */
  findId(element) {
    if (!element) return;
    if (element.getAttribute('aria-controls')) {
      return element.getAttribute('aria-controls');
    }
    if (element.getAttribute('id')) {
      return element.getAttribute('id');
    }
  }

  /**
   * Activate the button
   * @param {HTMLElement} button - The button to activate
   */
  activate(button) {
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('active');
  }

  /**
   * Deactivate the button
   * @param {HTMLElement} button - The button to deactivate
   */
  deactivate(button) {
    button.setAttribute('aria-expanded', 'false');
    button.classList.remove('active');
  }

  /**
   * Show the tab
   * @param {HTMLElement} tab - The tab to show
   */
  show(tab) {
    tab.classList.add('active');
    tab.setAttribute('aria-hidden', 'false');
  }

  /**
   * Hide the tab
   * @param {HTMLElement} tab - The tab to hide
   */
  hide(tab) {
    tab.classList.remove('active');
    tab.setAttribute('aria-hidden', 'true');
  }

  /**
   * Control the tabs element by activating and deactivating the buttons and tabs
   * @param {HTMLElement} button - The button that was clicked
   */
  controller(button) {
    if (!button) return;

    // Only toggle if the button is not the active one
    const id = this.findId(button);
    if (id === this.active) return;
    this.active = id;

    // Activate and deactivate the buttons
    this.buttons.forEach((button) => {
      const buttonId = this.findId(button);
      const isActive = buttonId === this.active;
      isActive ? this.activate(button) : this.deactivate(button);
    });

    // Show and hide the tabs
    this.tabs.forEach((tab) => {
      const tabId = this.findId(tab);
      const isActive = tabId === this.active;
      isActive ? this.show(tab) : this.hide(tab);
    });
  }
}

customElements.define('tabs-element', TabsElement);
